<template>
  <v-row no-gutters class="pt-5 pr-2">
    <v-col v-if="!isLoading">
      <card-title-row translation-path="sidebar.billing" />
      <card-title-row is-subtitle translation-path="sidebar.legalization" class="pt-5" />
      <template v-if="isFetched">
        <sidebar-row border-bottom>
          <sidebar-summary
            :checkboxes-values="checkedLegalizations"
            :items="legalizationSummaryItems"
            class="py-6"
            @updateCheckboxesValues="updateCheckboxesValues"
          >
            <template v-for="item of legalizationSummaryItems" #[item.name]="">
              {{ legalizationSummaryLegalization[item.name] }}
            </template>
          </sidebar-summary>
        </sidebar-row>
        <sidebar-row>
          <sidebar-summary :items="otherSummaryItems" class="py-6">
            <template v-for="item of otherSummaryItems" #[item.name]="">
              {{ legalizationSummaryReplacement[item.name] }}
            </template>
          </sidebar-summary>
        </sidebar-row>
      </template>
      <template v-else>
        <main-loader> </main-loader>
      </template>
    </v-col>
    <main-loader v-else />
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';

import CardTitleRow from '@/components/CardTitleRow';
import MainLoader from '@/components/MainLoader';
import SidebarSummary from '@/components/SidebarSummary';
import SidebarRow from '@/components/SidebarRow';

export default {
  name: 'Legalization',
  components: {
    SidebarRow,
    CardTitleRow,
    MainLoader,
    SidebarSummary,
  },
  data: () => ({
    checkedLegalizations: ['before_due', 'soon_past_due', 'past_due', 'no_data'],
    isFetched: false,
    isLoading: true,
  }),
  computed: {
    legalizationStatusesTranslations: get('admin/modulesMapping@billing.legalization_status_mapping'),
    legalizationSummaryLegalization: get('billings/legalizationSummary@legalization'),
    legalizationSummaryReplacement: get('billings/legalizationSummary@replacement'),
    waterMetersDataSourceName: get('admin/modulesMapping@billing.watermeters_datasource_name'),
    legalizationStatusAttributeName: get(
      'admin/modulesMapping@billing.watermeters_datasource_attributes_mapping.legalization_status_attribute_name'
    ),
    legalizationSummaryItems() {
      return [
        {
          name: 'before_due',
          straightText: this.legalizationStatusesTranslations['before_due'],
          color: 'rgba(24,128,56)',
          checkboxValue: 'before_due',
          chipTooltip: this.$i18n.t('sidebar.beforeDueLegalizationTooltip'),
        },
        {
          name: 'soon_past_due',
          straightText: this.legalizationStatusesTranslations['soon_past_due'],
          color: 'rgba(255,136,0)',
          checkboxValue: 'soon_past_due',
          chipTooltip: this.$i18n.t('sidebar.soonPastDueLegalizationTooltip'),
        },
        {
          name: 'past_due',
          straightText: this.legalizationStatusesTranslations['past_due'],
          color: 'rgba(191,54,12)',
          checkboxValue: 'past_due',
          chipTooltip: this.$i18n.t('sidebar.pastDueLegalizationTooltip'),
        },
        {
          name: 'no_data',
          straightText: this.legalizationStatusesTranslations['no_data'],
          color: 'rgba(108,108,108)',
          checkboxValue: 'no_data',
          chipTooltip: this.$i18n.t('sidebar.noDataLegalizationTooltip'),
        },
      ];
    },
    otherSummaryItems() {
      return [
        {
          name: 'current_year',
          translationPath: 'sidebar.replacement_in_current_year',
          color: 'rgba(0,145,234)',
        },
        {
          name: 'next_year',
          translationPath: 'sidebar.replacement_in_next_year',
          color: 'rgba(0,145,234)',
        },
      ];
    },
  },
  methods: {
    getLegalizationSummary: call('billings/getLegalizationSummary'),
    updateCheckboxesValues(nV) {
      this.checkedLegalizations = nV;
      this.setFilter();
    },
    setFilter() {
      const mappedValues = this.checkedLegalizations.map(
        legalization => this.legalizationStatusesTranslations[legalization]
      );
      this.$root.$emit('setSidebarFilters', {
        [this.legalizationStatusAttributeName]:
          mappedValues.length < 1 ? this.$_objectToArray(this.legalizationStatusesTranslations) : mappedValues,
      });
    },
    toggleLegalizationVisualisation(nV) {
      this.$root.$emit('toggleLegalizationVisualisation', nV);
    },
    updateLegalizationVisualisationMapLegend() {
      this.isFetched = true;
    },
    async watermetersFetched() {
      this.toggleLegalizationVisualisation(true);
      this.isFetched = true;
    },
    async init() {
      await this.getLegalizationSummary();
      this.isLoading = false;
    },
  },
  mounted() {
    this.$root.$emit('setAdditionalFilters', undefined);
    this.$root.$on('watermetersFetched', this.watermetersFetched);
    this.$root.$on('updateLegalizationVisualisationMapLegend', this.updateLegalizationVisualisationMapLegend);
    this.toggleLegalizationVisualisation(true);
    this.init();
  },
  beforeDestroy() {
    this.$root.$off('watermetersFetched');
    this.$root.$off('updateLegalizationVisualisationMapLegend');
  },
};
</script>
<style lang="scss" scoped>
.divider-row {
  @include border(bottom);
}
</style>
